import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const createStore = () => {
  return new Vuex.Store({
    state: {
      drawer: false,
      snackbar: {
        isVisible: false,
        message: '',
        color: '',
      },
    },
    mutations: {
      toggleDrawer(state) {
        state.drawer = !state.drawer
      },
      showSnackbar(state, payload) {
        state.snackbar.message = payload.message
        state.snackbar.color = payload.color
        state.snackbar.isVisible = true
      },
      hideSnackbar(state) {
        state.snackbar.isVisible = false
      },
    },
    actions: {
      TOGGLE_DRAWER({ commit }) {
        commit('toggleDrawer')
      },
    },
    getters: {
      DRAWER_STATE(state) {
        return state.drawer
      },
    },
  })
}

export default createStore
